import { useSugerencia } from "../../../features/catalogo/sugerencia_empaque/hooks/useSugerencia";
import { SugerenciaTableSkeleton } from "../../../features/catalogo/sugerencia_empaque/components/tableSkeleton";
import { AgregarSugerenciaEmpaque } from "../../../features/catalogo/sugerencia_empaque/components/agregar";
import { EditarSugerenciaEmpaque } from "../../../features/catalogo/sugerencia_empaque/components/editar";
import { useState } from "react";
import Swal from "sweetalert2";
import { Card, CardBody, CardHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function SugerenciaEmpaquePage() {
  const {
    sugerencias,
    isSlowLoading,
    isLoading,
    deleteSugerencia,
    getSugerenciaList,
  } = useSugerencia();
  const [isAdding, setIsAdding] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedSugerencia, setSelectedSugerencia] = useState(null);

  const onDelete = (id, active) => {
    Swal.fire({
      icon: "warning",
      text: `¿Está seguro que desea ${active ? "desactivar" : "activar"} la sugerencia de empaque?`,
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: active ? "Desactivar" : "Activar",
      cancelButtonText: "Cancelar",
      preConfirm: async () => {
        try {
          await deleteSugerencia(id);
        } catch (error) {
          Swal.showValidationMessage(`
            Request failed: ${error}
          `);
        }
      },
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((res) => {
      if (res.isConfirmed) {
        Swal.fire({
          icon: "success",
          text: `Sugerencia de empaque ${active ? "desactivada" : "activa"}`,
          timer: 1500,
        });
        getSugerenciaList();
      }
    });
  };

  const onEdit = (sugerencia) => {
    setSelectedSugerencia(sugerencia);
    setIsEditing(true);
    setIsAdding(false);
  };

  const onCancel = () => {
    setIsAdding(false);
    setIsEditing(false);
    setSelectedSugerencia(null);
  };

  const onAddingClick = () => {
    setIsAdding((prev) => !prev);
    setIsEditing(false);
    setSelectedSugerencia(null);
  };

  const onRefresh = () => {
    onCancel();
    getSugerenciaList();
  };

  return (
    <Card className="m-2">
      <CardHeader>Sugerencia de empaque</CardHeader>
      <CardBody>
        {isSlowLoading && (
          <div className="alert alert-warning mb-3">
            La consulta está tardando más de lo esperado...
          </div>
        )}
        <div>
          <button className="btn btn-primary" onClick={() => onAddingClick()}>
            <FontAwesomeIcon icon="fa-solid fa-plus" /> Nueva sugerencia
          </button>
        </div>
        <div className="d-flex flex-column flex-lg-row gap-2">
          <div className="table-responsive flex-grow-1">
            <table className="table">
              <thead>
                <tr>
                  <th>Alias</th>
                  <th>ORG/CON</th>
                  <th>Peso envase</th>
                  <th>Tipo caja</th>
                  <th>Etiqueta</th>
                  <th>Bultos</th>
                  <th>Activo</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <SugerenciaTableSkeleton />
                ) : (
                  sugerencias?.map((item) => (
                    <tr key={item.id}>
                      <td>{item.alias}</td>
                      <td>{item.tipo_etiqueta}</td>
                      <td>{item.peso_envase}</td>
                      <td>{item.tipo_caja}</td>
                      <td>{item.etiqueta}</td>
                      <td>{item.bultos}</td>
                      <td>{item.activo ? "Si" : "No"}</td>
                      <td>
                        {item.activo && (
                          <button
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => onEdit(item)}
                          >
                            <FontAwesomeIcon icon="fa-solid fa-pen" />
                          </button>
                        )}{" "}
                        <button
                          className={`btn btn-sm ${item.activo ? "btn-outline-danger" : "btn-outline-success"}`}
                          onClick={() => onDelete(item.id, item.activo)}
                        >
                          <FontAwesomeIcon icon="fa-solid fa-power-off" />
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          {isAdding && (
            <AgregarSugerenciaEmpaque
              onRefresh={onRefresh}
              onCancel={onCancel}
            />
          )}
          {isEditing && (
            <EditarSugerenciaEmpaque
              sugerencia={selectedSugerencia}
              onCancel={onCancel}
              onRefresh={onRefresh}
            />
          )}
        </div>
      </CardBody>
    </Card>
  );
}
